export default `
    <input type='text' id='#= data.id #' class='clearable-input module-search' autocomplete='no!'/><div class='clear-input'></div><a id='#= data.iconId #' class='list mar-t-5'></a>
`;
